 <template>
  <div>
    <loading :active.sync="isLoading" color="#0B253E"></loading>
    <div id="app">
      <div class="content-wrapper">
        <div class="container-fluid">
          <img class="logo" src="../../public/assets/img/max_compliance_logo.jpeg" alt>
          <div class="box_general padding_bottom">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Login</label>
                  <input type="text"
                    class="form-control"
                    placeholder="Login"
                    v-model="user.email"
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">

                  <label>Senha</label>
                  <input
                    type="password"
                    class="form-control"
                    placeholder="Senha"
                    v-model="user.password"
                    @keyup.enter="login"
                  >
                </div>
              </div>
              <div class="col-md-12 d-flex justify-content-center mt-2">
                <button class="btn_1 medium" type="button" @click="login()">Logar</button>
              </div>
              <div class="col-md-12 d-flex justify-content-center">
                <button class="btn-link medium" type="button" @click="esqueceuSenha()">Esqueceu a senha?</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ajax, tratamento_requisicao, alerta } from "../utils/util";
import funcoesGerais from "../assets/js/funcoes.js";
const jwt_decode = require('jwt-decode');
export default {
  mixins: [funcoesGerais],
  data: function() {
    return {
      user: {
        email: "",
        password: ""
      },
      isLoading: false,
      erroLogin: false,
      erroMensagem: "Tente novamente"
    };
  },
  methods: {
    login() {
      let self = this;

      if (self.user.email && self.user.password) {
        self.isLoading = true;
        ajax("post", "autentica_adm", {
          email: self.user.email,
          password: self.user.password
        })
        .then(response => {
          self.isLoading = false;

          localStorage.setItem("token_max", response.token)
          var decoded = jwt_decode(response.token);
          let tipo = decoded.role;

          if (tipo == 1) {
            self.$router.replace(self.$route.query.redirect || "/adm_master/painel");
          } else {
            alerta('error','Atenção',"Usuário não autorizado");
          }
        })
        .catch(error => {
          self.isLoading = false;
          tratamento_requisicao(error);
        });
      } else {
        alerta('danger','Atenção',"Preencha os campos");
      }
      return false;
    },
    esqueceuSenha() {
      this.$router.push('/esqueceu_senha')
    }
  }
};
</script>
<style scoped>
.box_general {
  display: table;
  margin: 5% auto;
  width: 30%;
}
.content-wrapper {
  margin-left: 0px;
  background-color: #fff;
}
#exampleAccordion {
  display: none;
}
.logo {
  display: table;
  width: 350px;
  margin: 0 auto;
  padding: 10px;
  border-radius: 20px;
  background-color: #0B253E;
}

body {
  background-color: #f8f8f8 !important;
}
</style>
